import * as React from "react";

export const SvgBackToTop = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none" {...props}>
		<path
			d="M9.7292 2.21792L4.96787 6.97925C4.67737 7.26975 4.67737 7.74088 4.96788 8.03138C5.25844 8.32194 5.72945 8.32194 6.02001 8.03138L9.51131 4.54008L9.51131 17.256C9.51131 17.6669 9.84443 18 10.2553 18C10.6661 18 10.9992 17.6669 10.9992 17.256L10.9992 4.54008L14.4905 8.03126C14.7811 8.32182 15.2521 8.32182 15.5427 8.03126C15.6878 7.88604 15.7606 7.69559 15.7606 7.5052C15.7606 7.3148 15.6878 7.12441 15.5427 6.97913L10.7813 2.21792C10.4908 1.92736 10.0198 1.92736 9.7292 2.21792Z"
			fill="#222222"
		/>
	</svg>
);
